export default __webpack_public_path__ + "static/media/AneomiOpen1.fb9eeb3a.jpg";